import type { FrontendWidget } from '../../types';
import { SingleTextComponent } from './SingleTextComponent';
import type { SingleTextConfig, SingleTextResolved } from './types';

export const singleTextWidget: FrontendWidget<
  SingleTextConfig,
  SingleTextResolved
> = {
  componentType: 'content-blocks.single-text',
  displayName: 'Single Text',
  defaultValues: { text: 'Text', textStyle: 'body', alignment: 'left' },
  ComponentA: SingleTextComponent,
  resolveSync: (config) => config,
};
